<template>
  <v-autocomplete
    v-bind="$attrs"
    v-on="$listeners"
    outlined
    :no-data-text="NO_DATA_TEXT"
  >
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </v-autocomplete>
</template>

<script>
import { NO_DATA_TEXT } from '@/constants';

export default {
  name: 'Autocomplete',
  data: () => ({
    NO_DATA_TEXT,
  }),
};
</script>
